export enum UserRoles {
  GlobalAdmin = 'Global Admin',
  MaintenanceAdmin = 'Maintenance Admin',
  ClientUser = 'Client User',
  InternalEngagementAdmin = 'Internal_Engagement_Admin',
  Presenter = 'Presenter'
}
